import { useEffect, useRef, useState } from 'react';
import { weddingConfig } from '@/data/weddingConfig';

/**
 * Optional, discreet floating music control.
 * Renders nothing unless `weddingConfig.music.enabled` is true.
 * Playback only ever starts on an explicit user tap — never autoplay.
 */
export default function MusicToggle() {
  const { enabled, src, title } = weddingConfig.music;
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (!enabled || !src) return;
    const audio = new Audio(src);
    audio.loop = true;
    audioRef.current = audio;
    return () => {
      audio.pause();
      audioRef.current = null;
    };
  }, [enabled, src]);

  if (!enabled || !src) return null;

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    } else {
      audio.pause();
      setPlaying(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={playing ? 'Pausar música' : 'Reproducir música'}
      title={title}
      className="fixed bottom-5 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-primary-300/60 bg-background-50/80 text-primary-600 backdrop-blur-sm transition-colors duration-300 hover:bg-background-50 hover:border-primary-400 cursor-pointer"
    >
      {playing ? (
        <i className="ri-pause-line text-lg" />
      ) : (
        <i className="ri-music-2-line text-lg" />
      )}
    </button>
  );
}